import * as stylex from '@stylexjs/stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { keyframes } from '@stylexjs/stylex';

const skeletonLoading = keyframes({
  '0%': {
    backgroundPosition: '200% 0',
  },
  '100%': {
    backgroundPosition: '-200% 0',
  },
});

export const styles = stylex.create({
  drawerContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-40'],
    alignSelf: 'stretch',
  },
  infoGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-12'],
    alignSelf: 'stretch',
    borderRadius: anatomy.borderRadiusS,
  },
  titleBlock: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-8'],
  },
  guestName: {
    overflow: 'hidden',
    color: colors.primaryText,
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Demi,
    fontStyle: 'normal',
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-4'],
  },
  badge: {
    display: 'flex',
    padding: `2px ${anatomy['space-8']}`,
    justifyContent: 'center',
    alignItems: 'center',
    gap: anatomy['space-8'],
    borderRadius: anatomy.borderRadiusRound,
    background: palette['green-200'],
  },
  badgeText: {
    overflow: 'hidden',
    color: palette['green-700'],
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
  },
  badgeSecondary: {
    display: 'flex',
    padding: `2px ${anatomy['space-8']}`,
    justifyContent: 'center',
    alignItems: 'center',
    gap: anatomy['space-8'],
    borderRadius: anatomy.borderRadiusRound,
    background: '#C5D6F9',
  },
  badgeTextSecondary: {
    overflow: 'hidden',
    color: '#385999',
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
  },
  infoTable: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
    alignSelf: 'stretch',
  },
  dataRow: {
    display: 'flex',
    padding: anatomy.spaceNo,
    alignItems: 'flex-start',
    gap: anatomy['space-16'],
    alignSelf: 'stretch',
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: anatomy['space-16'],
    alignSelf: 'stretch',
  },
  fieldLabel: {
    display: 'flex',
    width: '86px',
    alignItems: 'flex-start',
    gap: anatomy['space-10'],
    alignSelf: 'stretch',
    color: colors.tertiaryText,
    fontFamily: fonts.din2014Regular,
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-4'],
  },
  dottedLine: {
    display: 'flex',
    height: '17px',
    width: '148px',
    alignItems: 'flex-start',
    gap: anatomy['space-10'],
    borderBottom: `1px solid ${colors.tertiaryBorder}`,
  },
  fieldValue: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: anatomy['space-4'],
    alignSelf: 'stretch',
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-4'],
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    minWidth: 0,
  },
  details: {
    display: 'flex',
    paddingTop: anatomy['space-12'],
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-4'],
    alignSelf: 'stretch',
  },
  detailsTitle: {
    overflow: 'hidden',
    color: colors.tertiaryText,
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Regular,
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-4'],
  },
  detailsFrame: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy.spaceNo,
    alignSelf: 'stretch',
  },
  detailsFrameCheck: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-4'],
  },
  skeleton: {
    height: '20px',
    borderRadius: anatomy.borderRadiusS,
    background: `linear-gradient(90deg, ${colors.tertiaryBackground} 25%, ${colors.ghostBackground} 50%, ${colors.tertiaryBackground} 75%)`,
    backgroundSize: '200% 100%',
    animationName: skeletonLoading,
    animationDuration: '1.5s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
  },
  skeletonName: {
    width: '180px',
    height: '20px',
  },
  skeletonBadge: {
    width: '100px',
    height: '20px',
  },
  skeletonLabel: {
    width: '86px',
    height: '17px',
  },
  skeletonValue: {
    flex: 1,
    height: '17px',
  },
});
